const SET_LEAD = "lead/SET_LEAD";

export const setLead = (lead) => ({ type: SET_LEAD, payload: lead });

const initialState = { lead: {} };

const leadReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LEAD:
      return { ...state, lead: action.payload };
    default:
      return state;
  }
};

export default leadReducer;
